import { Avatar as NAvatar, type AvatarProps as NAvatarProps } from '@natera/material/lib/avatar'
import { useUserStore } from '../model'

export function Avatar(props: NAvatarProps) {
  const userInfo = useUserStore((state) => state.userInfo)
  const name = (userInfo?.name || '') as string

  return <NAvatar {...props}>{name[0]}</NAvatar>
}
